import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

interface VerticalSwitcherProps {
  className?: string;
  children: ReactNode;
}

/*
 * Style.
 */

const StyledContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 64px;
  padding-top: 6px;
  background: ${(p) => p.theme.verticalSwitcher.background};
  overflow-y: auto;
`;

/*
 * Component.
 */

export const VerticalSwitcher: FC<VerticalSwitcherProps> = (props) => {
  const {children, className} = props;
  return <StyledContainerDiv className={className}>{children}</StyledContainerDiv>;
};
